module.exports = __webpack_public_path__ + "img/thanks_image.8de69df.svg";